const UserPermission = {

    // FIELDS
    "user_permission": "User Permission",
    "permission": "Permission",

    // PAGE HEADER
    "assign_permission": "Assign Permission",

    // ERROR
    "error_user": "Select User",
    "error_permission": "Select Permission",

}

export default UserPermission;

